import { getSubnotes } from '../utilities/getSubnotes.js';
import './Notes.scss';

function Notes(props) {
    var xmlRoot = props.noteXML.getElementsByTagName("notes")[0];
    return getSubnotes(props.noteXML, props.setNoteXML, xmlRoot);
}

export default Notes;
